import { render } from "./B2bTableGenralsReceived.vue?vue&type=template&id=018ecab4&scoped=true&lang=pug"
import script from "./B2bTableGenralsReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableGenralsReceived.vue?vue&type=script&lang=js"

import "./B2bTableGenralsReceived.vue?vue&type=style&index=0&id=018ecab4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018ecab4"]])

export default __exports__